import { render, staticRenderFns } from "./rel-notas-fiscais.vue?vue&type=template&id=5320245f&"
import script from "./rel-notas-fiscais.vue?vue&type=script&lang=js&"
export * from "./rel-notas-fiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports